import React from 'react';
import Header from '../Share/Header/Header';

const About = () => {
    return (
        <div>
            <Header></Header>
            <h1>About Us</h1>
        </div>
    );
};

export default About;